<template>
  <div>
    <div v-if="isInProgress">
      <div class="d-flex" v-if="inProgressStats.remaining.num > 0">
        <span v-if="uploadSpeed">Upload speed: {{ uploadSpeed }}</span>
        <span class="ml-2">Total Files: {{ inProgressStats.total.num }} - {{ inProgressStats.total.size }}</span>
        <span class="mx-2">Remaining Files: {{ inProgressStats.remaining.num }} - {{ inProgressStats.remaining.size }}</span>
        <CProgress v-if="inProgressStats.progress > 0"
                   class="progress-xs p-uploader__progress-in-bar"
                   :precision="1"
                   :value="inProgressStats.progress"
        />
        {{ inProgressStats.progress.toFixed(2) }}%
      </div>
    </div>
    <div v-else>
      <span v-if="toUploadStats.num > 0">Total Files: {{ toUploadStats.num }} - {{ toUploadStats.size }}</span><br>
    </div>
  </div>
</template>

<script>

import fileUtils from "@/domain/core/utils/fileUtils";

export default {
  name: "UploaderStats",
  props: {
    toUpload: {
      type: Array,
      required: true
    },
    completed: {
      type: Array,
      required: true
    },
    inProgress: {
      type: Array,
      required: true
    },
    isInProgress: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    uploadSpeed() {
      if (this.inProgress.length <= 0) return null
      const speed = this.inProgress.reduce((acc, row) => {
        if (!row.speed || isNaN(row.speed)) return acc
        return acc + row.speed
      }, 0)
      return fileUtils.formatBytes(speed) + '/s'
    },
    inProgressStats() {
      const bytesToUpload = this.getTotalBytes(this.inProgress)
      const bytesCompleted = this.getTotalBytes(this.completed)
      const bytesUploaded = this.getTotalUploaded(this.inProgress)
      const bytesRemaining = bytesToUpload - bytesUploaded
      const bytesTotal = bytesToUpload + bytesCompleted

      return {
        total: {
          num: this.inProgress.length + this.completed.length,
          size: fileUtils.formatBytes(bytesTotal)
        },
        remaining: {
          num: this.inProgress.length,
          size: fileUtils.formatBytes(bytesRemaining),
        },
        progress: 100 - (bytesRemaining / bytesTotal) * 100,
      }
    },
    toUploadStats() {
      return {
        num: this.toUpload.length,
        size: fileUtils.formatBytes(this.getTotalBytes(this.toUpload))
      }
    },
  },
  methods: {
    getTotalBytes(files) {
      return files.reduce((acc, row) => acc + row.size, 0)
    },
    getTotalUploaded(files) {
      return files.reduce((acc, row) => {
        const progress = (row.progress ?? 0) / 100.0
        const remaining = row.size * progress
        return acc + remaining
      }, 0)
    }
  }
}
</script>

<style scoped>

</style>